<ng-template #settingsTemplate>
    <app-tool-setting label="Waarden" class="slider-groups">
        <div class="slider-group">
            <app-range-slider [max]="9" [(range)]="rangeModel.T" label="T"></app-range-slider>
            <app-range-slider [max]="9" [(range)]="rangeModel.E" label="E"></app-range-slider>
        </div>
    </app-tool-setting>
</ng-template>
<ng-template #contentTemplate>
    <svg id="Laag_1"
         data-name="Laag 1"
         xmlns="http://www.w3.org/2000/svg"
         viewBox="0 0 97 97.25"
         style="height: 150px">
        <defs>
            <style>.teD-1{fill:#eaf4fb;}.teD-2{fill:#1d1d1b;}.teD-3,.teD-4{fill:none;stroke:#0090c9;}.teD-3{stroke-width:1.5px;}.teD-4{stroke-width:1.23px;}.teD-5{font-size:28px;font-family:UniversLTStd, Univers LT Std;}</style>
        </defs>
        <title>DBS_TE_schema</title>
        <rect class="teD-1"
              y="1.25"
              width="97"
              height="48" />
        <path class="teD-2"
              d="M24,36.13V18.29H17.19V15.91H33.51v2.38H26.74V36.13Z"
              transform="translate(0 -0.75)" />
        <path class="teD-2"
              d="M66.89,15.91H79.57v2.38H69.69v6.3H79.1V27H69.69v6.72H79.8v2.46H66.89Z"
              transform="translate(0 -0.75)" />
        <line class="teD-3"
              x1="48.66"
              y1="1.25"
              x2="48.66"
              y2="97.25" />
        <line class="teD-4"
              y1="49.75"
              x2="97"
              y2="49.75" />
        <line class="teD-3"
              y1="0.75"
              x2="97"
              y2="0.75" />
        <text class="teD-5"
              transform="translate(65.22 84.77)">{{rangeModel.E}}</text>
        <text class="teD-5"
              transform="translate(16.22 84.77)">{{rangeModel.T}}</text>
    </svg>
</ng-template>

